import { mapToCanActivate, Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { AtLeastAdministratorRoleGuard } from '@next/core-lib/authorization';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { MonitorImportComponent } from './mowing-monitor/components/monitor-import/monitor-import.component';
import { NotificationsImportComponent } from './mowing-monitor/components/notifications-import/notifications-import.component';
import { MowingMonitorEffects } from './mowing-monitor/store/mowing-monitor.effects';
import { mowingMonitorReducer } from './mowing-monitor/store/mowing-monitor.reducer';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/monitor-import',
    pathMatch: 'full',
  },
  {
    path: '',
    providers: [
      provideState('mowing-monitor', mowingMonitorReducer),
      provideEffects([MowingMonitorEffects]),
    ],
    children: [
      {
        path: 'monitor-import',
        component: MonitorImportComponent,
        canActivate: mapToCanActivate([AtLeastAdministratorRoleGuard]),
      },
      {
        path: 'notifications-import',
        component: NotificationsImportComponent,
        canActivate: mapToCanActivate([AtLeastAdministratorRoleGuard]),
      },
    ],
  },
  ...coreRoutes,
];
